import api from 'api';

export const loadStatuses = api('GET /api/smart-rules/filters/statuses');

export const loadShowModes = api('GET /api/smart-rules/filters/show-modes');

export const loadTypes = api('GET /api/smart-rules/filters/types');

export const loadAffiliates = api('GET /api/smart-rules/filters/affiliates');

export const loadNetworks = api('GET /api/smart-rules/filters/networks');

export const loadApplications = api(
  'GET /api/smart-rules/filters/applications'
);

export const loadPlatforms = api('GET /api/smart-rules/filters/platforms');

export const loadCreatedBy = api('GET /api/smart-rules/filters/created-by');

export const loadChannels = api('POST /api/smart-rules/filters/channels');
